import { TableIds } from '../../../../../enums/tableIds'

export const getTrackingEvents = (tableId: string) => {
  const eventMap = {
    [TableIds.QuotesTable]: {
      rowClicked: '',
    },
    [TableIds.ClientQuotesTable]: {
      rowClicked: '',
    },
  } as const

  return eventMap[tableId]
}
